<template>
  <div class="schoolConsuReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="time-box flex-al fs14" style="width: 260px">
            <el-date-picker
              v-model="filterList.rangeTime"
              @change="search"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 150px"
              @change="(filter.channel_id = ''), getChannelData(), search()"
              v-model="filter.client_source"
              :placeholder="$t('Report1.placeholder5')"
            >
              <el-option
                v-for="item in filterList.SchoolsourceOption"
                :key="item.frommedia_id"
                :label="item.frommedia_name"
                :value="item.frommedia_name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 150px"
              @change="search"
              v-model="filter.channel_id"
              :placeholder="$t('Report1.placeholder6')"
            >
              <el-option
                v-for="item in filterList.ChannelOption"
                :key="item.channel_id"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 150px"
              @change="search"
              v-model="filter.is_invite"
              :placeholder="$t('Analysisreport.cd')"
            >
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 150px"
              @change="search"
              v-model="filter.is_invite_arrive"
              :placeholder="$t('Analysisreport.ce')"
            >
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 150px"
              @change="search"
              v-model="filter.client_tracestatus"
              :placeholder="$t('Analysisreport.bf')"
            >
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')" value="0"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')" value="1"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')" value="2"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')" value="3"></el-option>
              <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')" value="4"></el-option>
              <el-option
                :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')"
                value="-1"
              ></el-option>
              <el-option
                :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')"
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666">{{$t('Analysisreport.cf')}}:</span>
          <div class="select-box flex-al">
            <el-input
              clearable
              @clear="search"
              @blur="search"
              :placeholder="$t('Analysisreport.cg')"
              v-model="filter.track_num"
            ></el-input>
          </div>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
// import reportType from "@/components/report/reportType5";
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport";
export default {
  name: "analysisreport-schoolConsuReport",
  data() {
    return {
      openMenu: ["8"],
      reportParams: {
        wayString: "schoolClientRerport", //传递到子组件的方法名称
        Title: "校招生咨询分析表",
      },

      filterList: {
        rangeTime: [],
        SchoolsourceOption: [],
        ChannelOption: [], // 招生渠道明细
        coursetypeList: [],
        courseCatList: [],
      },

      filter: {
        start_time: "",
        end_time: "",
        keyword: "",
        track_num: "",
        is_invite: "",
        is_invite_arrive: "",
        client_source: "",
        channel_id: "",
        client_tracestatus: "",
        coursetype_id: "",
        coursecat_id: "",
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.filterList.rangeTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.start_time = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.end_time = this.$Common.getAppointedDate(2, 0).endDate;

    this.getSourceData();
    this.getChannelData();
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
  },
  mounted() {},
  methods: {
    //获取招生渠道类型
    getSourceData() {
      http
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.filterList.SchoolsourceOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      http
        .getChannel({
          channel_medianame: this.filter.client_source,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.ChannelOption = data.list;
          } else {
            this.filterList.ChannelOption = [];
          }
        });
    },
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.coursetypeList = data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    search() {
      this.filter.start_time = this.filterList.rangeTime
        ? this.filterList.rangeTime[0]
        : "";
      this.filter.end_time = this.filterList.rangeTime
        ? this.filterList.rangeTime[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.schoolConsuReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
